// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2vykb","modalForm":"UpgradeEpcsModal_modalForm__3RBuN","modalFooter":"UpgradeEpcsModal_modalFooter__j26dZ"};